import classNames from "classnames/bind";
import useStructuredDataContext from "common/providers/structuredData/useStructuredDataContext";
import { useEffect } from "react";
import styles from "./FAQ.module.scss";
import type { QaProps } from "./QA";
import QA from "./QA";
import slugify from "slugify";

const cx = classNames.bind(styles);

export type FAQProps = {
    title: string;
    subTitle?: string;
    questions: QaProps[];
    isAlternateTheme?: boolean;
    clearBackground?: boolean;
    openByDefaultAnchor?: string;
    handleCustomOpen?: any;
    forceOpen?: boolean;
    contentWrapperClassName?: string;
    isTopicSection?: boolean;
    isSubSection?: boolean;
    isTopFaqSection?: boolean;
    section?: string;
    isStaticPage?: boolean;
    isStructuredData: boolean;
};

const FAQ = ({
    title,
    subTitle,
    questions,
    isAlternateTheme,
    clearBackground,
    openByDefaultAnchor,
    forceOpen,
    handleCustomOpen,
    contentWrapperClassName,
    isTopicSection,
    isSubSection,
    isTopFaqSection,
    section,
    isStaticPage,
    isStructuredData,
}: FAQProps) => {
    if (isStructuredData) {
        const { createFaqStructuredData } = useStructuredDataContext();

        useEffect(() => {
            if (questions.length) createFaqStructuredData(questions);
        }, [createFaqStructuredData, questions]);
    }

    return (
        <div
            id={slugify(title, { lower: true })}
            className={cx("container", {
                isSubSection,
                isTopicSection,
                isAlternateTheme,
                clearBackground,
                isTopFaqSection,
                isStaticPage,
            })}
        >
            {title && !isSubSection && <h2 className={cx("title")}>{title}</h2>}{" "}
            {isSubSection && <h3 className={cx("title")}>{title}</h3>}
            {subTitle && !isAlternateTheme && <span className={cx("subTitle")}>{subTitle}</span>}
            <div className={cx("contentWrapper", contentWrapperClassName)}>
                {questions.map((question, index) => {
                    const openByDefault = !forceOpen
                        ? (openByDefaultAnchor &&
                              question.anchor &&
                              question.anchor === openByDefaultAnchor) ||
                          false
                        : !!question.openByDefault;

                    return (
                        <QA
                            {...question}
                            isAlternateTheme={isAlternateTheme}
                            isStaticPage={isStaticPage}
                            clearBackground={clearBackground}
                            key={question.question}
                            openByDefault={openByDefault}
                            handleCustomOpen={handleCustomOpen}
                            isTopicSection={isTopicSection}
                            isSubSection={isSubSection}
                            index={question.index}
                            section={section}
                            isTopFaqSection={isTopFaqSection}
                            anchor={`${question.index || index}-${slugify(question.question, {
                                lower: true,
                            })}`}
                        />
                    );
                })}
            </div>
        </div>
    );
};

export default FAQ;
